'use strict';

var _ = require('lodash');
var BookingsIntakeTooltipFactory = function BookingsIntakeTooltipFactory() {
  var tooltipContent = _.template(require('../templates/bookings-intake-tooltip.html'));
  var HIDE_DELAY = 50;
  var SHOW_DELAY = 50;
  function BookingsIntakeTooltip() {}
  BookingsIntakeTooltip.constructor = BookingsIntakeTooltip;
  BookingsIntakeTooltip.prototype.getBuilder = function (mappedMode) {
    //mappedMode set to true should take REGULAR bookings (this is intended)
    return function (cellData, wholeGridData) {
      var rowData = wholeGridData[cellData.row];
      var bookingIntakeFieldName = mapBookingIntakeFieldName(cellData.column || 'bookingsIntakeHtml');
      if (rowData[bookingIntakeFieldName] && rowData[bookingIntakeFieldName].length > 0) {
        var tooltipData = {
          daysToDeparture: rowData.daysToDeparture,
          bookingsTotal: getBookingsTotal(rowData, mappedMode),
          bookingsIntakeData: rowData[bookingIntakeFieldName]
        };
        return {
          htmlContent: tooltipContent(tooltipData).replace(/>\s*</g, '><'),
          hideDelay: HIDE_DELAY,
          showDelay: SHOW_DELAY,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  function mapBookingIntakeFieldName(columnName) {
    return _.replace(columnName, 'Html', 'Data');
  }
  var getBookingsTotal = function getBookingsTotal(data, mappedMode) {
    return data.bookingsTotal || data.currentBookings || data.segClassCurrentBookings || data.resHoldTotal || (mappedMode ? data.regularReservationHoldingsTotal || data.bookings : data.mappedReservationHoldingsTotal || data.bookingsMappedTotal || data.mappedBookings) || 0;
  };
  return BookingsIntakeTooltip;
};
module.exports = BookingsIntakeTooltipFactory;